import alertsHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/alerts-header.png';
import alertsSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/alerts-section1.png';
import alertsSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/alerts-section2.png';
import alertsSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/alerts-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_ALERTS: PageblockData = {
  headerData: {
    headerText: 'Set up seamless Salesforce & Slack integration',
    subHeaderText:
      'Connect your team to the revenue process with real-time Salesforce updates directly in Slack.',
    imgSrc: alertsHeader,
    imgAlt: 'Alerts header',
    name: 'Alerts',
  },
  pageTitle: 'Turn key pipeline events into actionable alerts',
  section1: {
    imgSrc: alertsSection1,
    imgAlt: 'Alerts section img',
    title: 'Custom alerts & notifications',
    content:
      'Automate the creation and updating of Salesforce records to maintain data integrity and optimize workflows across teams.',
  },
  section2: {
    imgSrc: alertsSection2,
    imgAlt: 'Alerts section 2 img',
    title: 'Update Salesforce directly from Slack',
    content:
      'Enable your team to update Salesforce directly from Slack, turning notifications into actionable tasks without leaving the platform.',
  },
  section3: {
    imgSrc: alertsSection3,
    imgAlt: 'Alerts section 3 img',
    title: 'Automate deal room creation & updates',
    content:
      'Automate the creation and updates of deal rooms in Slack based on key events to keep your team aligned and up-to-date.',
  },
};
